import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminProducts = lazy(() => import("@/pages/admin/AdminProducts"));

export const Route = createFileRoute("/admin/produkter")({
  component: () => <AdminProducts />,
});
